import { render } from "./SelectionFormWl.vue?vue&type=template&id=2a5db133"
import script from "./SelectionFormWl.vue?vue&type=script&lang=js"
export * from "./SelectionFormWl.vue?vue&type=script&lang=js"

import "./SelectionFormWl.vue?vue&type=style&index=0&id=2a5db133&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__